<script>
  import { page } from '@inertiajs/svelte'

  import Main from "../layouts/_main.svelte"

  import { I18n } from "i18n-js"
  import i18n_translations from "../../javascript/locales.json"

  import {
    blog_post_path
  } from '../../javascript/routes'

  let { RailsApp, posts } = $props()

  const i18n = new I18n(i18n_translations)
  i18n.locale = RailsApp.I18n.locale

  function formatDate(dateString) {
    const date = new Date(dateString)
    return date.toLocaleDateString(RailsApp.I18n.locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
  }
</script>

<Main {...$page.props}>
  <section class="container py-5">
    <h1 class="mb-4">{i18n.t('Blog.title', { defaultValue: 'Blog' })}</h1>

    <div class="row">
      {#each posts as post}
        <div class="col-12 mb-4">
          <article>
            <h2 class="lh-base">
              <a href={blog_post_path(post.slug, { locale: RailsApp.I18n.locale })} class="text-decoration-none">
                {post.title}
              </a>
            </h2>
            <p class="text-muted small mb-2">
              {formatDate(post.publishedAt)}
            </p>
            <p>
              {post.description}
            </p>
          </article>
        </div>
      {/each}
    </div>
  </section>
</Main>
